/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_k$ as k$,
  rec_y$ as y$,
} from "../../runtime/index.jsx";
export function Componente_jDolar_106_36(e, t) {
  return (
    <li
      key={t}
      className={`flex flex-col`}
      children={[
        <span
          className={`text-(--text-h)`}
          children={[k$[e.accion] ?? e.accion, e.quien ? ` · ${e.quien}` : ``]}
        />,
        e.detalle && (
          <span
            className={`break-words text-xs text-(--text)`}
            children={e.detalle}
          />
        ),
        <span className={`text-xs text-(--text)`} children={y$(e.cuando)} />,
      ]}
    />
  );
}
